import React from 'react';
import '../styles/bizofficer-a.css';

export default function Execute() {
  var etlStudentObj = JSON.parse(localStorage.getItem('etlStudentObj'));

  function goLoc(opt){
    if(opt===1){
      window.location.href="profile";
    }
  }

  return (<>
      {!window.navigator.onLine?
        <div className='netBar' >Alert: It seems, you are not connected to the internet.</div>
      :null}
      {(etlStudentObj && (!etlStudentObj.emailId || (etlStudentObj.emailId && etlStudentObj.emailId==='null')) )?
			  <div className='profileBar' onClick={()=>{goLoc(1)}} >Add your email address for Account Recovery & Teacher Support by clicking here</div>
      :null}

    </>);
}
